import { LocalizedDate, LocalizedText, WallClockDate } from '@mews/framework';
import { getShortDayNameKey } from './utils/getShortDayNameKey';

export const LocalizedDateWithDay = ({ date }: { date: WallClockDate }) => (
    <span>
        <LocalizedText textKey={getShortDayNameKey(date)} /> <LocalizedDate date={date} />
    </span>
);
